import { TypeEmpresa } from "../Pessoa/Empresa"
import { TypeRegistro } from "./PlanoContasTipoRegistro"
import { TypePlanoContasTipo } from "./PlanoContasTipo"
import { TypeProporcao } from "./Proporcao"

export type TypePlanoContas = {
    codigo?: number,
    codigoContabil?: string,
    empresa?: TypeEmpresa,
    tipoRegistro?: TypeRegistro,
    tipo?: TypePlanoContasTipo,
    descricao?: string,
    grupo?: TypePlanoContas,
    subGrupo?: TypePlanoContas,
    operador?: number,
    ativo?: boolean,
    dataCricacao?: Date,
    proporcoes?: TypeProporcao[]
}

export function formatarCodigoContabil(data:TypePlanoContas)
{
    return [data.grupo?.codigoContabil, data.subGrupo?.codigoContabil, data.codigoContabil].filter(f => (f?.length ?? 0) > 0).join("")
}